import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { menuConfig } from "./AppLayout.constants";
export var getMenu = function (t, userInfo) {
    return menuConfig.filter(function (item) { var _a; return ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.role) ? (_a = item.visibleFor) === null || _a === void 0 ? void 0 : _a.includes(userInfo === null || userInfo === void 0 ? void 0 : userInfo.role) : true); }).map(function (item) { return getItem(_jsx(Link, { to: "".concat(item.path), children: t("sidebar.menu.".concat(item.key)) }), item.key, item.icon); });
};
function getItem(label, key, icon) {
    return {
        key: key,
        icon: icon,
        label: label,
    };
}
